"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _makeStylesInternal = _interopRequireDefault(require("./../makeStyles/makeStylesInternal"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _tokens = require("../styles/tokens");
var _excluded = ["className", "classes", "disabled", "onClick", "handleClose"];
var useStyles = (0, _makeStylesInternal.default)(function (theme) {
  return {
    root: {
      // Since menu list item is pulling from MUI, have to override to match recommended list
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeight,
      lineHeight: _tokens.lineHeightParagraphMedium,
      textOverflow: 'ellipsis',
      '&.padding': {
        padding: _tokens.spacing40,
        display: 'block'
      },
      '&:hover': {
        color: "" + theme.palette.grey[600],
        backgroundColor: theme.palette.grey[250]
      },
      '&:focus': {
        color: "" + theme.palette.grey[600],
        backgroundColor: theme.palette.grey[250],
        boxShadow: "0 0 0 " + _tokens.borderWidthThick + " " + theme.palette.focus + " inset"
      },
      '&:active': {
        backgroundColor: theme.palette.grey[300],
        color: "" + theme.palette.grey[600]
      }
    }
  };
});

/**
 * An item in the dropdown version of the Button component?
 */
var DropdownButtonItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var localClasses = useStyles();
  var className = props.className,
    classes = props.classes,
    disabled = props.disabled,
    _onClick = props.onClick,
    handleClose = props.handleClose,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var _React$useState = _react.default.useState(false),
    isSelected = _React$useState[0],
    setIsSelected = _React$useState[1];
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)(localClasses.root, className, 'padding'),
    disabled: disabled,
    onClick: function onClick(e) {
      setIsSelected(true);
      handleClose && handleClose(e);
      _onClick && _onClick(e);
    },
    classes: classes,
    ref: ref,
    role: "option",
    "aria-selected": isSelected
  }));
});
DropdownButtonItem.muiName = 'DropdownButtonItem';
DropdownButtonItem.displayName = 'DropdownButtonItem';
DropdownButtonItem.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Class name to assign the component.
   */
  className: _propTypes.default.string,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * If `true`, the dropdown menu item will be disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * Callback triggered when dropdown menu item is clicked.
   */
  onClick: _propTypes.default.func.isRequired,
  /**
   * @ignore
   */
  handleClose: _propTypes.default.func
};
DropdownButtonItem.defaultProps = {
  disabled: false
};
var _default = exports.default = DropdownButtonItem;